import React from 'react';
import { CubeJsGraphBase } from './base';


export abstract class CardGraphBase extends CubeJsGraphBase {
    abstract graphSubtitle(): string

    processValue(value: any): any {
      if (Number.isNaN(value)) {
        return value;
      }
      return Number(value).toLocaleString();
    }


    queryRender(props) {
      const data = props.resultSet.chartPivot();

      const rawValue = CardGraphBase.getSingleNumberFromRenderProps(props);
      const value = this.processValue(rawValue);

      return (
        <div className="graph-number h-100">
          <h1 style={{ textAlign: 'center' }}>{value}</h1>
          <div className="graph-subtitle">{this.graphSubtitle()}</div>
        </div>
      );
    }
}
